import { Component, Input } from '@angular/core';
import { OrderHeadDeliveryFormGroup } from '../../order-head-edit/order-head-edit.component';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { FormGroup } from '@angular/forms';
import { CustomerItem, PostPlaceItem, TypeaheadService } from '@app/services/typeahead.service';
import { BusinessItem, CoopItem, CountryItem } from '@app/services/logistic.service';
import { CustomerEditGet, CustomerService } from '@app/services/customer.service';

@Component({
    selector: 'tt-order-head-delivery-address-form',
    templateUrl: './order-head-delivery-address-form.component.html',
    styleUrls: ['./order-head-delivery-address-form.component.css'],
})
export class OrderHeadDeliveryAddressFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public form?: FormGroup<OrderHeadDeliveryFormGroup>;

    @Input()
    public countries: CountryItem[] = [];

    @Input()
    public businesses: BusinessItem[] = [];

    @Input()
    public coops: CoopItem[] = [];

    constructor(
        private typeahead: TypeaheadService,
        private customer: CustomerService,
    ) {}

    public searchDeliveryCustomers = (params?: { [key: string]: any }) => {
        return this.typeahead.searchCustomer({ cust_name: params?.['value'] ?? '', lastselect: 'SEARCH', custtype: 'D' });
    };

    public searchPostplaces = (params?: { [key: string]: any }) => {
        return this.typeahead.searchPostplaces({ searchtext: params?.['value'] ?? '' });
    };

    public async onDeliveryCustomerSelected(event?: CustomerItem) {
        this.form?.patchValue({ delivery_cust_no: event?.item_id ?? '0', delivery_cust_name: event?.item_name ?? '' });

        let customer: CustomerEditGet | null = null;

        try {
            if (+(this.form?.controls.delivery_cust_no.value ?? 0) > 0) {
                customer = await this.customer?.getCustomerEdit({ cust_no: this.form?.controls.delivery_cust_no.value ?? '0' });
            }
        } catch (error) {
            console.error(error);
        }

        this.form?.patchValue({
            delivery_cust_no: customer?.cust_no ?? '0',
            delivery_cust_name: customer?.cust_name ?? '',
            delivery_cust_address: customer?.cust_address ?? '',
            delivery_cust_phone: customer?.cust_telephone ?? '',
            delivery_email: customer?.cust_email ?? '',
            delivery_business_id: customer?.cust_business_id ?? '',
            delivery_coop_id: customer?.cust_coop_id ?? '',
            delivery_postplace_id_street: customer?.postplace_id_street ?? '',
            delivery_postplace_id: customer?.postplace_id ?? '',
            delivery_adr_street: customer?.cust_adr_street ?? '',
            delivery_adr_mail: customer?.cust_adr_mail ?? '',
            delivery_postplace_name: customer?.postplace_name_onlyname ?? '',
            delivery_postplace_name_street: customer?.postplace_name_street_onlyname ?? '',
        });
    }

    public onPostPlaceStreetNameSelected(event?: PostPlaceItem) {
        this.form?.patchValue({ delivery_postplace_id_street: event?.item_id ?? '0', delivery_postplace_id_and_name_street: event?.item_name ?? '' });
    }

    public onPostplaceNameSelected(event?: PostPlaceItem) {
        this.form?.patchValue({ delivery_postplace_id: event?.item_id ?? '0', delivery_postplace_id_and_name: event?.item_name ?? '' });
    }
}
